import { service } from './service'
// 系统多服务配置，对应后端的context-path配置
const path = service

export default path
